export default {
  header: 'ניהול קרנות אלטרנטיביות',
  alternativeFunds: 'מספרי קרן אלטרנטיבית',
  number: 'מספר קרן אלטרנטיבית',
  addNewAlternativeFund: 'הוספת קרן אלטרנטיבית',
  accordType: 'עמלה',
  uid: 'מספר מזהה',
  company: 'חברה מנהלת',
  commission: 'עמלה %',
  branch: 'מוצר',
  success: 'קרן אלטרנטיבית נוסף בהצלחה',
  alternativeFundType: 'סוג קרן אלטרנטיבית',
  alternativeFundName: 'שם קרן אלטרנטיבית',
};
